import { Map, List, fromJS } from 'immutable'
import * as actions from './actions'

export const initialState = Map({
  currentProfile: Map({
    data: Map(),
    processing: false,
    error: null,
  }),
  memberProfile: Map({
    data: Map(),
    processing: false,
    error: null,
  }),
  update: Map({
    processing: false,
    error: null,
    success: false,
  }),
  follow: Map({
    processing: false,
    error: null,
  }),
  tagOptions: Map({
    data: List(),
    vibes: List(),
    topics: List(),
    processing: false,
    error: null,
  }),
  followers: Map({
    edges: List(),
    pageInfo: Map({ hasNextPage: false, endCursor: null }),
    totalCount: 0,
    processing: false,
    error: null,
  }),
  following: Map({
    edges: List(),
    pageInfo: Map({ hasNextPage: false, endCursor: null }),
    totalCount: 0,
    processing: false,
    error: null,
  }),
  playlists: Map({
    data: List(),
    processing: false,
    error: null,
  }),
  watchingTags: Map({
    data: List(),
    processing: false,
  }),
  inProgress: Map({
    data: List(),
    processing: false,
  }),
  communitySpaces: Map({
    data: List(),
    processing: false,
  }),
  activitySummary: Map({
    comments: 0,
    reactions: 0,
    groups: 0,
    processing: false,
  }),
  sharedPlaylistDetails: Map({
    data: Map(),
    processing: false,
  }),
  profilePictures: Map({
    data: Map(),
    processing: false,
    error: null,
  }),
  avatarUpload: Map({
    processing: false,
    error: null,
    success: false,
  }),
  avatarDelete: Map({
    processing: false,
    error: null,
    success: false,
  }),
  welcomeBannerDismissed: false,
  activeTab: 'identity',
  activity: Map({
    data: List(),
    processing: false,
    filter: 'all',
  }),
})

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_COMMUNITY_PROFILE_CURRENT: {
      const payload = action.payload || {}
      let next = state
        .setIn(['currentProfile', 'data'], fromJS(payload))
        .setIn(['currentProfile', 'error'], null)
      const avatar = payload.userInfo && payload.userInfo.avatar
      if (payload.uid && avatar) {
        next = next.setIn(
          ['profilePictures', 'data', String(payload.uid)],
          fromJS(avatar),
        )
      }
      return next
    }

    case actions.SET_COMMUNITY_PROFILE_CURRENT_PROCESSING:
      return state.setIn(['currentProfile', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_CURRENT_ERROR:
      return state.setIn(['currentProfile', 'error'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_MEMBER: {
      const payload = action.payload || {}
      let next = state
        .setIn(['memberProfile', 'data'], fromJS(payload))
        .setIn(['memberProfile', 'error'], null)
      const avatar = payload.userInfo && payload.userInfo.avatar
      if (payload.uid && avatar) {
        next = next.setIn(
          ['profilePictures', 'data', String(payload.uid)],
          fromJS(avatar),
        )
      }
      return next
    }

    case actions.SET_COMMUNITY_PROFILE_MEMBER_PROCESSING:
      return state.setIn(['memberProfile', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_MEMBER_ERROR:
      return state.setIn(['memberProfile', 'error'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_UPDATE_PROCESSING:
      return state.setIn(['update', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_UPDATE_SUCCESS: {
      const existing = state.getIn(['currentProfile', 'data'])
      const response = fromJS(action.payload || {})
      const updated = existing && existing.size > 0
        ? existing.merge(response)
        : response
      return state
        .setIn(['update', 'success'], true)
        .setIn(['update', 'error'], null)
        .setIn(['currentProfile', 'data'], updated)
    }

    case actions.SET_COMMUNITY_PROFILE_UPDATE_ERROR:
      return state
        .setIn(['update', 'error'], action.payload)
        .setIn(['update', 'success'], false)

    case actions.SET_COMMUNITY_PROFILE_FOLLOW_PROCESSING:
      return state.setIn(['follow', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_FOLLOW_ERROR:
      return state.setIn(['follow', 'error'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_TAG_OPTIONS: {
      const { data, vibes, topics } = action.payload
      return state
        .setIn(['tagOptions', 'data'], fromJS(data))
        .setIn(['tagOptions', 'vibes'], fromJS(vibes))
        .setIn(['tagOptions', 'topics'], fromJS(topics))
        .setIn(['tagOptions', 'error'], null)
    }

    case actions.SET_COMMUNITY_PROFILE_TAG_OPTIONS_PROCESSING:
      return state.setIn(['tagOptions', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_TAG_OPTIONS_ERROR:
      return state.setIn(['tagOptions', 'error'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_FOLLOWERS:
      return state
        .setIn(['followers', 'edges'], fromJS(action.payload.edges || []))
        .setIn(['followers', 'pageInfo'], fromJS(action.payload.pageInfo || {}))
        .setIn(['followers', 'totalCount'], action.payload.totalCount || 0)
        .setIn(['followers', 'error'], null)

    case actions.SET_COMMUNITY_PROFILE_FOLLOWERS_PROCESSING:
      return state.setIn(['followers', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_FOLLOWERS_ERROR:
      return state.setIn(['followers', 'error'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_FOLLOWING:
      return state
        .setIn(['following', 'edges'], fromJS(action.payload.edges || []))
        .setIn(['following', 'pageInfo'], fromJS(action.payload.pageInfo || {}))
        .setIn(['following', 'totalCount'], action.payload.totalCount || 0)
        .setIn(['following', 'error'], null)

    case actions.SET_COMMUNITY_PROFILE_FOLLOWING_PROCESSING:
      return state.setIn(['following', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_FOLLOWING_ERROR:
      return state.setIn(['following', 'error'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_ACTIVE_TAB:
      return state.set('activeTab', action.payload)

    case actions.SET_COMMUNITY_PROFILE_WELCOME_DISMISSED:
      return state.set('welcomeBannerDismissed', action.payload)

    case actions.SET_COMMUNITY_PROFILE_ACTIVITY_FILTER:
      return state.setIn(['activity', 'filter'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_PLAYLISTS:
      return state
        .setIn(['playlists', 'data'], fromJS(action.payload || []))
        .setIn(['playlists', 'error'], null)

    case actions.SET_COMMUNITY_PROFILE_PLAYLISTS_PROCESSING:
      return state.setIn(['playlists', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_PLAYLIST_VISIBILITY: {
      const { playlistId, visibility } = action.payload
      const playlistsList = state.getIn(['playlists', 'data'])
      const idx = playlistsList.findIndex((p) => p.get('id') === playlistId)
      if (idx === -1) return state
      return state.setIn(['playlists', 'data', idx, 'visibility'], visibility)
    }

    case actions.SET_COMMUNITY_PROFILE_WATCHING_TAGS:
      return state.setIn(['watchingTags', 'data'], fromJS(action.payload || []))

    case actions.SET_COMMUNITY_PROFILE_WATCHING_TAGS_PROCESSING:
      return state.setIn(['watchingTags', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_IN_PROGRESS:
      return state.setIn(['inProgress', 'data'], fromJS(action.payload || []))

    case actions.SET_COMMUNITY_PROFILE_IN_PROGRESS_PROCESSING:
      return state.setIn(['inProgress', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_COMMUNITY_SPACES:
      return state.setIn(['communitySpaces', 'data'], fromJS(action.payload || []))

    case actions.SET_COMMUNITY_PROFILE_COMMUNITY_SPACES_PROCESSING:
      return state.setIn(['communitySpaces', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY:
      return state
        .setIn(['activitySummary', 'comments'], action.payload.comments || 0)
        .setIn(['activitySummary', 'reactions'], action.payload.reactions || 0)
        .setIn(['activitySummary', 'groups'], action.payload.groups || 0)

    case actions.SET_COMMUNITY_PROFILE_ACTIVITY_SUMMARY_PROCESSING:
      return state.setIn(['activitySummary', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_SHARED_PLAYLIST_DETAILS:
      return state.setIn(
        ['sharedPlaylistDetails', 'data'],
        fromJS(action.payload || {}),
      )

    case actions.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_PROCESSING:
      return state.setIn(['avatarUpload', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_SUCCESS:
      return state
        .setIn(['avatarUpload', 'success'], true)
        .setIn(['avatarUpload', 'error'], null)
        .setIn(['avatarUpload', 'processing'], false)

    case actions.SET_COMMUNITY_PROFILE_AVATAR_UPLOAD_ERROR:
      return state
        .setIn(['avatarUpload', 'error'], action.payload)
        .setIn(['avatarUpload', 'success'], false)
        .setIn(['avatarUpload', 'processing'], false)

    case actions.SET_COMMUNITY_PROFILE_AVATAR_DELETE_PROCESSING:
      return state.setIn(['avatarDelete', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_AVATAR_DELETE_SUCCESS:
      return state
        .setIn(['avatarDelete', 'success'], true)
        .setIn(['avatarDelete', 'error'], null)
        .setIn(['avatarDelete', 'processing'], false)

    case actions.SET_COMMUNITY_PROFILE_AVATAR_DELETE_ERROR:
      return state
        .setIn(['avatarDelete', 'error'], action.payload)
        .setIn(['avatarDelete', 'success'], false)
        .setIn(['avatarDelete', 'processing'], false)

    case actions.SET_COMMUNITY_PROFILE_PICTURES:
      return state
        .updateIn(['profilePictures', 'data'], (existing) => existing.merge(fromJS(action.payload || {})))
        .setIn(['profilePictures', 'error'], null)

    case actions.SET_COMMUNITY_PROFILE_PICTURES_PROCESSING:
      return state.setIn(['profilePictures', 'processing'], action.payload)

    case actions.SET_COMMUNITY_PROFILE_PICTURES_ERROR:
      return state.setIn(['profilePictures', 'error'], action.payload)

    default:
      return state
  }
}
